var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"syncc-stories-feed__video-loading-K8eklU93N",style:(_vm.containerStyle)},[_c('img',{staticClass:"syncc-stories-feed__video-loading-img-2OnBFLZ7",attrs:{"src":_vm.loader}})])}
var staticRenderFns = []

export { render, staticRenderFns }